import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "update-syntax-popover-content" }
const _hoisted_2 = { class: "dropdown-menu" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "update-syntax-popover-content" }
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "operations" }

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipContent',
  props: {
    showGenerateImage: {}
  },
  emits: ['updateSyntax', 'hidePopper', 'generateImage', 'updateTone'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showArrow = ref(false);
const showArrow2 = ref(false);
const customPrompt = ref('');
const customPromptRef = ref(null);
const grammars = [
  { label: '润色', type: 'grammar' },
  { label: '扩写', type: 'grammar' },
  { label: '简写', type: 'grammar' },
  { label: '续写', type: 'grammar' },
];
const tones = [
  { label: '正式的', type: 'tone' },
  { label: '随意的', type: 'tone' },
  { label: '专业的', type: 'tone' },
  { label: '热情的', type: 'tone' },
  { label: '幽默的', type: 'tone' },
];

const handleFocus = (event: any) => {
  const element = event.target;
  if (element.innerText === customPrompt.value) {
    element.innerText = '';
  }
};

const handleGenerateImage = () => {
  emit('generateImage');
};

const showElPopper = (type: string) => {
  if (type === 'updateSyntax') {
    showArrow.value = true;
  }
  if (type === 'adjustTone') {
    showArrow2.value = true;
  }
};

// 隐藏popper
const hideElPopper = (type: string) => {
  if (type === 'updateSyntax') {
    showArrow.value = false;
  }
  if (type === 'adjustTone') {
    showArrow2.value = false;
  }
};

const handleUpdateSyntax = (requirements: string, type: string) => {
  emit('updateSyntax', requirements, type);
};

const handleInput = (event: any) => {
  customPrompt.value = event.target.innerText;
};

const handleClick = (event: any) => {
  // This function now stops propagation and prevents default behavior
};

const hidePopper = () => {
  emit('hidePopper');
};

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip-content",
    onMouseup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
  }, [
    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "logo" }, [
      _createElementVNode("img", { src: _imports_0 })
    ], -1)),
    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createVNode(_component_el_popover, {
      placement: "bottom",
      trigger: "click",
      "popper-class": "update-syntax-popover",
      teleported: false,
      "show-arrow": false,
      width: 110,
      onShow: _cache[1] || (_cache[1] = ($event: any) => (showElPopper('updateSyntax'))),
      onHide: _cache[2] || (_cache[2] = ($event: any) => (hideElPopper('updateSyntax')))
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "update-syntax",
          link: "",
          onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showArrow.value = true))
        }, {
          default: _withCtx(() => [
            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "ri-ai-generate" }, null, -1)),
            _createVNode(_component_el_text, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("修正语法")
              ])),
              _: 1
            }),
            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(grammars, (grammar) => {
              return _createElementVNode("button", {
                link: "",
                class: "dropdown-menu-item",
                key: grammar.label,
                onClick: ($event: any) => (handleUpdateSyntax(grammar.label, 'grammar'))
              }, _toDisplayString(grammar.label), 9, _hoisted_3)
            }), 64))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_popover, {
      placement: "bottom",
      "popper-class": "update-syntax-popover",
      trigger: "hover",
      "show-arrow": false,
      teleported: false,
      width: 110,
      onShow: _cache[4] || (_cache[4] = ($event: any) => (showElPopper('adjustTone'))),
      onHide: _cache[5] || (_cache[5] = ($event: any) => (hideElPopper('adjustTone')))
    }, {
      reference: _withCtx(() => [
        _createVNode(_component_el_button, {
          class: "update-syntax",
          link: "",
          onMouseenter: _cache[3] || (_cache[3] = ($event: any) => (showArrow2.value = true))
        }, {
          default: _withCtx(() => [
            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "ri-voiceprint-line" }, null, -1)),
            _createVNode(_component_el_text, null, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("调整语气")
              ])),
              _: 1
            }),
            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "ri-arrow-down-s-line" }, null, -1))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tones, (tone) => {
              return _createElementVNode("button", {
                link: "",
                class: "dropdown-menu-item",
                key: tone.label,
                onClick: ($event: any) => (handleUpdateSyntax(tone.label, tone.type))
              }, _toDisplayString(tone.label), 9, _hoisted_6)
            }), 64))
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.showGenerateImage)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "update-syntax",
          link: "",
          onClick: handleGenerateImage
        }, {
          default: _withCtx(() => [
            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "ri-image-edit-line" }, null, -1)),
            _createVNode(_component_el_text, null, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("生图")
              ])),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        class: "operations-btn",
        link: "",
        onClick: hidePopper
      }, {
        default: _withCtx(() => _cache[16] || (_cache[16] = [
          _createElementVNode("i", { class: "ri-close-line" }, null, -1)
        ])),
        _: 1
      })
    ])
  ], 32))
}
}

})